export class WSEventType {
  static CHANGE_VIEW = 'CHANGE_VIEW';
  static OFFER = 'OFFER';
  static AUTH_STATUS = 'AUTH_STATUS';
  static PING = 'PING';
  static PONG = 'PONG';
  static OFFER_MPAY = 'OFFER_MPAY';
  static AZTEC_SCANNED = 'AZTEC_SCANNED';
}
